import { PaymentTypeToFriendlyNameMapping } from '../../utils/FriendlyNameMappings';

export function mapPaymentType(rawPaymentType: string | undefined | null): string | undefined {
    if (!rawPaymentType) {
        return undefined;
    }

    return PaymentTypeToFriendlyNameMapping[rawPaymentType] ?? rawPaymentType;
}

export function formatAmount(invoiceAmount: any, invoiceCurrency: string | undefined | null): string {
    if (invoiceAmount == null || invoiceAmount === '') {
        return '';
    }

    if (invoiceCurrency) {
        return `${invoiceAmount} ${invoiceCurrency}`;
    }

    return String(invoiceAmount);
}
